import React, { memo } from 'react';
import PropTypes from 'prop-types';

import * as icons from '@/assets/icons';
import { config } from '@/config';

function Icon({ name, ...props }) {
  const icon = icons[name];

  if (!icon) {
    return null;
  }

  return (
    <svg viewBox={icon.viewBox} {...props}>
      <use xlinkHref={`${config.spriteUrl}#${icon.id}`} />
    </svg>
  );
}

Icon.propTypes = {
  name: PropTypes.string,
};

Icon.defaultProps = {
  name: '',
};

export default memo(Icon);
